import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/context/AuthContext";
import Pouch from "@/components/Pouch";

export default function Shop() {
  const [blends, setBlends] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => {
    axios.get(`${API}/blends`).then((r) => setBlends(r.data));
  }, []);

  const filtered = filter === "all" ? blends : blends.filter((b) => b.roast_level === filter);

  return (
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-32 pb-24">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
        <div>
          <div className="label-mono mb-4 text-[var(--primary)]">॥ Shop · All Blends ॥</div>
          <h1 className="font-sacred text-5xl md:text-7xl leading-none tracking-tight embossed-light">THE ROAST LOG.</h1>
          <p className="mt-6 text-[var(--text-secondary)] max-w-lg leading-relaxed">
            Every blend is small-batch roasted to order. Choose your grind at checkout.
          </p>
        </div>
        <div className="flex flex-wrap gap-2" data-testid="roast-filters">
          {["all", "light", "medium", "dark"].map((r) => (
            <button
              key={r}
              onClick={() => setFilter(r)}
              className={`label-mono px-4 py-2 border transition-colors ${
                filter === r
                  ? "border-[var(--primary)] text-[var(--primary)]"
                  : "border-[var(--border)] text-[var(--text-secondary)] hover:text-[var(--text)]"
              }`}
              data-testid={`filter-${r}`}
            >
              {r}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
        {filtered.map((b, i) => (
          <Link key={b.id} to={`/shop/${b.id}`} className="group block fade-up card-flat p-4 relative" style={{ animationDelay: `${i * 60}ms` }} data-testid={`blend-card-${b.id}`}>
            {b.most_popular && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20 pointer-events-none" data-testid={`popular-badge-${b.id}`}>
                <div className="px-4 py-1.5 whitespace-nowrap" style={{
                  background: "linear-gradient(180deg, #FF5C5F 0%, #E5383F 60%, #A3152A 100%)",
                  color: "#FFFFFF",
                  fontFamily: "'Fraunces', serif",
                  fontSize: "10px",
                  fontWeight: 700,
                  letterSpacing: "0.2em",
                  border: "1px solid #7A0F1F",
                  boxShadow: "0 1px 0 rgba(255,240,210,0.4) inset, 0 4px 12px rgba(0,0,0,0.25)",
                }}>
                  ★ MOST POPULAR ★
                </div>
              </div>
            )}
            <div className="aspect-[4/5] overflow-hidden relative" style={{ background: "var(--surface-warm)" }}>
              <div className="w-full h-full transition-transform duration-500 group-hover:scale-105">
                <Pouch blend={b} />
              </div>
              {b.featured && !b.most_popular && <span className="absolute top-3 left-3 badge z-10" style={{ background: "#0C1610", color: "#8BE3A9", borderColor: "#2F5A40" }}>Signature</span>}
              {b.most_popular && <span className="absolute top-3 left-3 badge z-10" style={{ background: "#0C1610", color: "#8BE3A9", borderColor: "#2F5A40" }}>High Selling</span>}
            </div>
            <div className="mt-6 flex justify-between items-start">
              <div>
                <div className="label-mono mb-2 text-[var(--text-muted)]">{b.origin}</div>
                <div className="font-serif text-2xl embossed-light">{b.name}</div>
                <div className="text-[var(--text-secondary)] mt-1 text-sm">{b.flavor_notes.join(" · ")}</div>
                <div className="label-mono mt-2 text-[var(--text-muted)]">{b.roast_level} roast</div>
              </div>
              <div className="text-right">
                <div className="font-mono text-sm text-[var(--primary-hover)]">₹{b.price_inr}</div>
                <div className="label-mono text-[9px] mt-1">250g</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
